export const FETCH_LOAD_ALL_WASTE_REQUEST = 'FETCH_LOAD_ALL_WASTE_REQUEST'
export const FETCH_LOAD_ALL_WASTE_SUCCESS = 'FETCH_LOAD_ALL_WASTE_SUCCESS'
export const FETCH_LOAD_ALL_WASTE_FALUIRE = 'FETCH_LOAD_ALL_WASTE_FALUIRE'

